import React from "react";

import banner_top from "../../../static/images/tutorial/banner-top.png";

const BannerTop = (props) => {
	return (
		<div className="banner-top">
			<div
				className="m-container"
				style={{
					backgroundImage: `url(${banner_top})`,
				}}>
				<div className="banner-top__title">
					<h1 dangerouslySetInnerHTML={{ __html: props.title ? props.title : `Chính sách & Quy&nbsp;định` }} />
				</div>
			</div>
		</div>
	);
};

export default BannerTop;
